import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
// import menus from "./../../config/app-menu.jsx";

function NavItem({ menu, ...props }) {
  let icon = menu.icon_front && (
    <div className="menu-icon">
      <i className={menu.icon_front}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret =
    menu.subMenu != undefined && menu.subMenu != "" ? (
      <div className="menu-caret"></div>
    ) : (
      ""
    );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );
  let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );
  let title = menu.name && (
    <div className="menu-text">
      {menu.name} {label} {highlight}
    </div>
  );

  let hasSubMenu = menu.subMenu && Object.keys(menu.subMenu).length > 0;

  return (
    <div className={`menu-item ${hasSubMenu ? " has-sub" : ""}`}>
      <NavLink className="menu-link" to={menu.path_front} {...props}>
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.subMenu && (
        <div className="menu-submenu">
          {Object.values(menu.subMenu).map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  const { menu } = useAppContext();
  const fetchedMenus = JSON.parse(menu);
//  // console.log(fetchedMenus);

  useEffect(() => {
    if (fetchedMenus) {
      setMenusState(Object.values(fetchedMenus));
    } else {
      setMenusState([]);
    }
  }, [menu]);

  const [menusState, setMenusState] = useState(
    fetchedMenus ? Object.values(fetchedMenus) : []
  );

  const initializeSubmenus = () => {
    const updatedMenus = menusState.map((menu) => {
      if (menu.subMenu && Object.keys(menu.subMenu).length > 0) {
        menu.subMenu = Object.values(menu.subMenu);
      }
      return menu;
    });
    setMenusState(updatedMenus);
  };

  useEffect(() => {
    initializeSubmenus();
  }, []);

  const payment = false; //if account not have make payment

  return (
    <>
      <div className="menu">
        {payment && (
          <>
            <div className="menu-header">Menu</div>
            <div className="menu-header">

              <p>No momento o sistema está inativo.</p>
            </div>
          </>
        )}
        {!payment && (
          <>
            <div className="menu-header">Menu</div>
            {menusState.map((menu, i) => (
              <NavItem key={i} menu={menu} />
            ))}
          </>
        )}
      </div>
    </>
  );
}

export default SidebarNav;
